import { render, staticRenderFns } from "./YoyoCoins.vue?vue&type=template&id=0ca6b918&scoped=true"
import script from "./YoyoCoins.vue?vue&type=script&lang=js"
export * from "./YoyoCoins.vue?vue&type=script&lang=js"
import style0 from "./YoyoCoins.vue?vue&type=style&index=0&id=0ca6b918&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ca6b918",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\work\\business\\yoyotravel\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0ca6b918')) {
      api.createRecord('0ca6b918', component.options)
    } else {
      api.reload('0ca6b918', component.options)
    }
    module.hot.accept("./YoyoCoins.vue?vue&type=template&id=0ca6b918&scoped=true", function () {
      api.rerender('0ca6b918', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/mine/YoyoCoins.vue"
export default component.exports